var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTerms = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 19807"
}, /*#__PURE__*/React.createElement("g", {
  fill: "none",
  "data-name": "Group 19798",
  transform: "translate(-40 -353.719)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  "data-name": "Ellipse 1638",
  transform: "translate(40 353.719)"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  "data-name": "Group 19769"
}, /*#__PURE__*/React.createElement("path", {
  d: "M52.559 377.55v-11.261a1.97 1.97 0 0 1 1.971-1.971h10.944a1.97 1.97 0 0 1 1.971 1.971v14.252a1.97 1.97 0 0 1-1.971 1.971h-7.953",
  "data-name": "Path 27420"
}), /*#__PURE__*/React.createElement("path", {
  d: "m52.559 377.549 4.962 4.962",
  "data-name": "Line 1701"
}), /*#__PURE__*/React.createElement("path", {
  d: "M52.559 377.549h2.913a2.05 2.05 0 0 1 2.049 2.05v2.913",
  "data-name": "Path 27421"
}), /*#__PURE__*/React.createElement("path", {
  d: "M55.856 368.227h8.27",
  "data-name": "Line 1702"
}), /*#__PURE__*/React.createElement("path", {
  d: "M64.126 371.535h-8.27",
  "data-name": "Line 1703"
}))))));
export { SvgTerms as ReactComponent };
export default __webpack_public_path__ + "static/media/terms.508f45598b48d1ff1446637eb4ebd121.svg";